import get from 'lodash/get';
import { createSelector } from 'reselect';
import { sharingSelector } from '../../sharing/selectors';
import { SCOPE } from './types';

const selector = state => (get(state, SCOPE));

export default selector;

export const loadingSelector = createSelector(selector,
  state => ({
    isFetching: state.isFetching,
  }));

export const aiAlertDiagnosticsUpdateSelector = createSelector(
  sharingSelector,
  sharingState => sharingState.state,
);
